import React from 'react';
import PropTypes from 'prop-types'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './QueuePage.scss'

const NotesHeaderSortLink = ({ sortKey, currentSortKey, reversed, onClick, children, renderLink }) =>
    (sortKey !== currentSortKey) ?
        <a id={'note-header-' + sortKey} className='queue-header-link' onClick={() => onClick(sortKey, !reversed)}>
            {children}
        </a>
        :
        <div id={'header-link-' + sortKey } className='header-sort-link' onClick={() => onClick(sortKey, !reversed)}>
            {children}
            <div className='header-direction-toggle' >
                {reversed &&
                    <ExpandLessIcon />
                }
                {!reversed &&
                    <ExpandMoreIcon />
                }
            </div>
        </div>

NotesHeaderSortLink.propTypes = {
    sortKey: PropTypes.string.isRequired,
    currentSortKey: PropTypes.string,
    reversed: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default NotesHeaderSortLink